module.exports = __webpack_public_path__ + "static/media/ourDetailedServices.36eddec6.png";